import React from 'react';
import { Component } from 'react';
import Pagination from 'react-bootstrap/Pagination';
import Select from "react-select"

class PaginationComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedValue: this.props.selectedValue,
            key: props.keyObjName,
            value: props.valueObjName,
            posPerpageList: [
                { label: 10, value: 10 },
                { label: 25, value: 25 },
                { label: 50, value: 50 },
                { label: 100, value: 100 },
            ]
        }
    }
    render() {
        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                borderBottom: '1px dotted pink',
                //   color: state.isSelected ? 'red' : 'blue',
                padding: "2px 8px",
            }),
            menu: (provided, state) => ({
                ...provided,
                width: "100%",
                minWidth: "max-content",
                zIndex: "999 !important",
            }),
            container:  (provided, state) => ({
                ...provided,
                // padding: "2px 8px",
            }),
            control:  (provided, state) => ({
                ...provided,
                // padding: "2px 8px",
                minHeight: "30px",
            })
        }
        console.log(this.props, "props")
        const { currentPage, posPerpage, totalPos } = this.props;
        var filteredTodos = []

        // Logic for displaying todos
        const indexOfLastTodo = parseInt(currentPage) * posPerpage;
        const indexOfFirstTodo = indexOfLastTodo - posPerpage;
        // const currentTodos = filteredTodos.slice(indexOfFirstTodo, indexOfLastTodo);
        const currentTodos = this.props.filteredTodos;

        // rendering current POs
        const renderTodos = currentTodos.map((todo, index) => {
            return <li key={index}>{todo}</li>;
        });

        // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(this.props.totalPos / posPerpage); i++) {
            pageNumbers.push(i);
        }
        console.log(pageNumbers, "pageNo.")
        // page number ui
        const renderPageNumbers = pageNumbers.map((number, index) => {
            let totalPages = pageNumbers.length
            if (index === 0) {
                return (
                    <>
                        <Pagination.First
                            key={"firstpage"}
                            id={number}
                            onClick={
                                parseInt(currentPage) === number
                                    ? () => { }
                                    : (e) => {
                                        this.props.handleClick(e);
                                    }
                            }
                        />
                        <Pagination.Prev
                            key={"prevpage"}
                            id={parseInt(currentPage) - 1}
                            onClick={
                                parseInt(currentPage) === number
                                    ? () => { }
                                    : (e) => {
                                        this.props.handleClick(e);
                                    }
                            }
                        />
                        <Pagination.Item
                            key={number}
                            active={parseInt(currentPage) === number ? true : false}
                            id={number}
                            onClick={
                                parseInt(currentPage) === number
                                    ? () => { }
                                    : (e) => {
                                        this.props.handleClick(e);
                                    }
                            }
                        >
                            {number}
                        </Pagination.Item>
                    </>
                );
            }
            if (parseInt(currentPage) <= 5) {
                if (number <= 8) {
                    return (
                        <>
                            <Pagination.Item
                                key={number}
                                active={parseInt(currentPage) === number ? true : false}
                                id={number}
                                onClick={
                                    parseInt(currentPage) === number
                                        ? () => { }
                                        : (e) => {
                                            this.props.handleClick(e);
                                        }
                                }
                            >
                                {number}
                            </Pagination.Item>
                        </>
                    );
                }
                if (number === 9) {
                    return (
                        <Pagination.Ellipsis key={number} />
                    )
                }
            }
            else if (totalPages - parseInt(currentPage) <= 4) {
                if ((totalPages - 8) === number) {
                    return (
                        <Pagination.Ellipsis key={number} />
                    )
                }
                if ((totalPages - 7) === number || (totalPages - 6) === number || (totalPages - 5) === number || (totalPages - 4) === number || (totalPages - 3) === number || (totalPages - 2) === number || (totalPages - 1) === number) {
                    return (
                        <Pagination.Item
                            key={number}
                            active={parseInt(currentPage) === number ? true : false}
                            id={number}
                            onClick={
                                parseInt(currentPage) === number
                                    ? () => { }
                                    : (e) => {
                                        this.props.handleClick(e);
                                    }
                            }
                        >
                            {number}
                        </Pagination.Item>
                    )
                }

            } else {
                if ((parseInt(currentPage) - 4) === number) {
                    return (
                        <Pagination.Ellipsis key={number} />
                    )
                }
                if ((parseInt(currentPage) - 3) === number || (parseInt(currentPage) - 2) === number || (parseInt(currentPage) - 1) === number || parseInt(currentPage) === number || (parseInt(currentPage) + 1) === number || (parseInt(currentPage) + 2) === number || (parseInt(currentPage) + 3) === number) {
                    return (
                        <Pagination.Item
                            key={number}
                            active={currentPage === number ? true : false}
                            id={number}
                            onClick={
                                parseInt(currentPage) === number
                                    ? () => { }
                                    : (e) => {
                                        this.props.handleClick(e);
                                    }
                            }
                        >
                            {number}
                        </Pagination.Item>
                    )
                }
                if ((parseInt(currentPage) + 4) === number) {
                    return (
                        <Pagination.Ellipsis key={number} />
                    )
                }
            }
            if (index === totalPages - 1) {
                return (
                    <>
                        <Pagination.Item
                            key={totalPages}
                            active={parseInt(currentPage) === number ? true : false}
                            id={totalPages}
                            onClick={
                                parseInt(currentPage) === number
                                    ? () => { }
                                    : (e) => {
                                        this.props.handleClick(e);
                                    }
                            }
                        >
                            {totalPages}
                        </Pagination.Item>
                        <Pagination.Next
                            key={"nextpage"}
                            id={parseInt(currentPage) + 1}
                            onClick={
                                parseInt(currentPage) === number
                                    ? () => { }
                                    : (e) => {
                                        this.props.handleClick(e);
                                    }
                            }
                        />
                        <Pagination.Last
                            key={"lastpage"}
                            id={totalPages}
                            onClick={
                                parseInt(currentPage) === number
                                    ? () => { }
                                    : (e) => {
                                        this.props.handleClick(e);
                                    }
                            }
                        />
                    </>
                )
            }
        });
        return (
            <Pagination size="sm" className=" pagination">
                {this.props.showPosPerpage ?
                    <li className="page-item" style={{ paddingRight: '10px', width: '100px' }}>
                        <Select maxMenuHeight={500} placeholder="Number of items" value={{ label: posPerpage, value: posPerpage }} options={this.state.posPerpageList} styles={customStyles} onChange={(e) => this.props.handleSelectPoPerPage(e)} />
                    </li>
                    : ""
                }
                <li className="page-item" style={{ paddingRight: '10px' }}>
                    <span className="page-link" style={{ border: 'none' }}>{indexOfLastTodo - posPerpage + 1}-{indexOfLastTodo < totalPos ? indexOfLastTodo : totalPos} / {totalPos}</span>
                </li>
                {renderPageNumbers}
            </Pagination>
        )
    }
}
export default PaginationComponent;

